<template>
  <div class="features-artists">
    <div class="hero-overflow-wrap">
      <FeaturesHero
        title="The profile your music deserves"
        :background-image="require('@/assets/img/features/hero-profile-hand.webp')"
      />
    </div>
    <div class="inner-content d-f fd-c">
      <ColText3
        title-html="The problem with music platforms"
        :columns="problemColumns"
      />
      <Col6BigImg
        title-html="Momentum <span class='title-grey'>in your city</span>"
        :cutout-image="require('@/assets/img/features/Ranking-desktop.webp')"
        :cutout-image-mobile="require('@/assets/img/features/Ranking-mobile.webp')"
        cutout-image-alt="Local artist rankings"
        right-title="Local charts"
        right-paragraph="Your rank isn’t just a stream count. It’s a ratio of real interactions—likes, comments, playlist adds—to unique plays. Chart in your area once you’ve earned enough listens. Until then you stay Unranked—fair signal, not noise."
        :image-bg-color="'var(--bg-color)'"
      />
      <Col6BigImg
        title-html="Genre-specific <span class='title-grey'>track rankings</span>"
        :cutout-image="require('@/assets/img/features/Tracks-Electro.webp')"
        :cutout-image-mobile="require('@/assets/img/features/Tracks-Electro-mob.webp')"
        cutout-image-alt="Genre track charts"
        right-title="Your niche"
        right-paragraph="Granular sub-genre charts mean you compete where your sound actually lives—not buried in a global top 100. The algorithm weighs plays, skips, and shares so trending reflects your community, not vanity metrics alone."
        :image-bg-color="'var(--bg-color)'"
      />
      <Col6BigImg
        title-html="Minimal layout. <span class='title-grey'>Maximum attitude.</span>"
        :cutout-image="require('@/assets/img/features/one-place-cutout.webp')"
        cutout-image-alt="Artist profile layout"
        right-title="Brutalist by design"
        right-paragraph="No bloated templates or stock dashboards. A stripped-back profile: strong structure, high contrast, music and identity first. Built for artists who care how they look online—editorial, not generic."
        :checklist="profileChecklist"
        :image-bg-color="'var(--bg-color)'"
      />
      <Col3ImgText
        title-html="One link. <span class='title-grey'>Your demos.</span>"
        :columns="oneFlowColumns"
        :image-bg-color="'var(--bg-color)'"
      />
    </div>
  </div>
</template>
<script>
import FeaturesHero from '@/components/features/FeaturesHero.vue'
import ColText3 from '@/components/features/3ColText.vue'
import Col6BigImg from '@/components/features/Col6BigImg.vue'
import Col3ImgText from '@/components/features/Col3ImgText.vue'

export default {
  name: 'FeaturesArtists',
  components: {
    FeaturesHero,
    ColText3,
    Col6BigImg,
    Col3ImgText,
  },
  data() {
    return {
      problemColumns: [
        {
          heading: '<span class="strike">Vanity metrics</span>',
          body: 'Global stream totals and one-size charts hide who’s actually moving in a scene. Hard to see real momentum where you live and play.',
        },
        {
          heading: '<span class="strike">Generic profiles</span>',
          body: 'Same tired layouts everywhere—bios lost in widgets, music buried under clutter. Nothing that feels like a release or a statement.',
        },
        {
          heading: '<span class="strike">Demos in the void</span>',
          body: 'Links in DMs and email threads disappear. No structure, no signal—just hoping someone listened.',
        },
      ],
      profileChecklist: [
        'Locations & genres up front',
        'Links and music in one scan',
        'Looks like a fanzine, not a form',
      ],
      oneFlowColumns: [
        {
          image: require('@/assets/img/features/demo-reviews/Drop.webp'),
          imageAlt: 'Submit demo',
          heading: 'Send one link',
          body: 'Labels on Algorhythm get your demo in their workflow—structured, not lost in the inbox swamp.',
          checklist: [],
        },
        {
          image: require('@/assets/img/features/demo-reviews/Rate.webp'),
          imageAlt: 'Charts and ranking',
          heading: 'Show up on charts',
          body: 'Earn plays and interactions where it counts—local scenes and the genres you actually make.',
          checklist: [],
        },
        {
          image: require('@/assets/img/features/demo-reviews/Reviews.webp'),
          imageAlt: 'Profile and presence',
          heading: 'Own your page',
          body: 'Your profile is the home base: minimal, brutalist, unmistakably you.',
          checklist: [],
        },
      ],
    }
  },
  metaInfo: {
    title: 'Features — For artists',
  },
}
</script>
<style lang="scss" scoped>
@import "@/scss/_variables.scss";
.features-artists {
  --bg-color: #111;
}
.hero-overflow-wrap {
  overflow-x: hidden;
}
.inner-content {
  gap: 200px;
  padding: 200px 0;
}
</style>
